export default "__VITE_ASSET__CQFQ$8Ys__"